export const EventType = {
  Message: 'RoutedMessage',
  Note: 'Note',
  SecureMessage: 'SecureMessage',
  DirectMessage: 'DirectMessage',
  HipaaConsent: 'HipaaConsent',
  AppointmentReminder: 'AppointmentReminder',
  AssignmentEvent: 'AssignmentEvent',
  RhinopayConsent: 'RhinopayConsent',
  SavedContent: 'SavedContent',
  MarketingConsent: 'MarketingConsent',
  VideoCall: 'VideoCall',
  SavedContentSent: 'SavedContentSent',
  PatientMerge: 'PatientMerge',
  CopyContent: 'CopyContent',
  Rhinoform: 'Rhinoform',
  AppointmentReminderNotification: 'AppointmentReminderNotification',
  AudioCall: 'AudioCall',
};

export const MessageStatus = {
  Queued: 'Queued',
  Delivered: 'Delivered',
  ConfirmedDelivered: 'Confirmed Delivered',
  Error: 'Error',
  ConfirmedError: 'Confirmed Error',
  NetworkError: 'Network Error',
};

export const EventDirection = {
  Queued: 'Queued',
  Delivered: 'Delivered',
  ConfirmedDelivered: 'Confirmed Delivered',
  Error: 'Error',
  ConfirmedError: 'Confirmed Error',
};

export const HipaaConsentStatus = {
  Pending: 'Pending',
  Granted: 'Granted',
  Decline: 'Declined',
};

export const QUERY_STATUS_FULFILLED = 'fulfilled';
